import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectAnnotateStopErrorModal,
  hideAnnotateStopErrorModal
} from '@clean-code/ducks/modal';
import {
  AnnotateStopErrorModal,
  AnnotateStopErrorModalErrorBoundary
} from '@clean-code/components/AnnotateStopErrorModal';

export const GlobalModals: React.FC = () => {
  const dispatch = useDispatch();
  const annotateStopErrorModal = useSelector(selectAnnotateStopErrorModal);

  return (
    <>
      {annotateStopErrorModal.isOpen && annotateStopErrorModal.data && (
        <AnnotateStopErrorModalErrorBoundary>
          <AnnotateStopErrorModal
            isOpen={annotateStopErrorModal.isOpen}
            onClose={() => dispatch(hideAnnotateStopErrorModal())}
            data={annotateStopErrorModal.data}
          />
        </AnnotateStopErrorModalErrorBoundary>
      )}
    </>
  );
};
